import {
    ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS,
    ADDORUPDATEUSERWITHDRAWLIMIT_FAILED,
    RESET_ADDORUPDATEUSERWITHDRAWLIMIT,
    LOADING_ADDORUPDATEUSERWITHDRAWLIMIT,
    NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATEUSERWITHDRAWLIMIT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADDORUPDATEUSERWITHDRAWLIMIT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADDORUPDATEUSERWITHDRAWLIMIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_ADDORUPDATEUSERWITHDRAWLIMIT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_ADDORUPDATEUSERWITHDRAWLIMIT:
            return (state = initialState);
        default:
            return state;
    }
};
